import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Link,
} from '@chakra-ui/react';
// eslint-disable-next-line no-restricted-imports
import { Field, Form, Formik } from 'formik';
import { FC, useState } from 'react';
import { Button } from 'src/components/atoms/Button';
import { ErrorNotifBox } from 'src/components/atoms/ErrorNotifBox';
import { useFontErrorColor } from 'src/hooks/colors/useErrorColor';
import { FormikField } from './types';
import { validateEmail } from './validators';

type ForgotPasswordSendCodeProps = {
  email?: string;
  onSubmit: (email: string) => void;
  onCancel?: () => void;
};

/**
 * This component shows is required when a user needs to set a new password
 * (usually at first sign in with a new account).
 */
export const ForgotPasswordSendCode: FC<ForgotPasswordSendCodeProps> = ({
  email,
  onSubmit,
  onCancel,
}) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const errorMessageColor = useFontErrorColor();

  return (
    <Formik
      initialValues={{
        email: email || '',
      }}
      onSubmit={async (values) => {
        try {
          setErrorMessage(null);
          await onSubmit(values.email);
        } catch (error) {
          if (error instanceof Error) {
            setErrorMessage(error.message);
          }
        }
      }}>
      {(props) => (
        <Form>
          <Field name="email" validate={validateEmail}>
            {({ field, form }: FormikField) => (
              <FormControl
                my={4}
                isInvalid={form.errors.email && form.touched.email}>
                <FormLabel htmlFor="email">Email</FormLabel>
                <Input
                  {...field}
                  id="email"
                  placeholder="first.last@email.com"
                  backgroundColor="surface.hover"
                  border="none"
                  borderRadius="md"
                />
                <FormErrorMessage color={errorMessageColor}>
                  {form.errors.email}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
          {errorMessage && <ErrorNotifBox title={errorMessage} />}
          <Flex direction="row" gap={4} mt={6}>
            {onCancel && (
              <Link
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="50%"
                fontFamily="marketingPage"
                fontSize="16px"
                fontWeight="semibold"
                onClick={onCancel}
                color="gray.500"
                _hover={{ textDecoration: 'underline' }}>
                Back to Login
              </Link>
            )}
            <Button
              buttonName="reset-password"
              width={onCancel ? '50%' : '100%'}
              bg="icon.green"
              borderRadius="8px"
              color="white"
              fontFamily="marketingPage"
              fontSize="16px"
              fontWeight="semibold"
              isLoading={props.isSubmitting}
              type="submit"
              _hover={{ opacity: 0.7 }}>
              Reset Password
            </Button>
          </Flex>
        </Form>
      )}
    </Formik>
  );
};
